import analytics from 'scripts/lib/analytics';
import fetchGuideCollections from 'actions/guide_performance/fetch_guide_collections';
import { handleCommonErrors } from 'scripts/application/lib/gateway_error_silent_handler';
import OrganizationConverter from 'scripts/application/dto_converters/organization_converter';
import isFeatureEnabled from 'actions/lib/is_feature_enabled';
import { NotExistError } from 'scripts/application/lib/error';

export default class RequestOrganization {
  constructor(context) {
    this.context = context;
  }

  run() {
    const { auth, organization: organizationStore } = this.context.stores;
    const { organizations } = this.context.gateways;

    const orgId = auth.get().getOrgId();
    organizationStore.setLoading();

    return organizations
      .fetch({ orgId })
      .then(dto => {
        const organization = OrganizationConverter.fromDto(dto);
        organizationStore.set(organization);
        analytics.updateUser({ loginDomain: organization.loginDomain });

        return this.updateSidekickStatus(organization);
      })
      .then(() => {
        fetchGuideCollections(this.context);
      })
      .catch(err => {
        handleCommonErrors(this.context, err);
      })
      .finally(() => {
        organizationStore.resetLoading();
      });
  }

  updateSidekickStatus(organization) {
    if (!isFeatureEnabled(this.context, 'viewGuidePerformance') && !isFeatureEnabled(this.context, 'answers:admin')) {
      return;
    }

    const { organization: organizationStore } = this.context.stores;
    const { sidekickOrganization: gateway } = this.context.gateways;

    return gateway
      .fetch()
      .then(() => {
        organization.setSidekickEnabled(true);
        organizationStore.set(organization);
      })
      .catch(err => {
        if (!(err instanceof NotExistError)) {
          throw err;
        }
      });
  }
}
